module.exports = __webpack_public_path__ + "static/img/qt_4.7050804.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/qt_4.png
// module id = PDgx
// module chunks = 1